<template>
  <div>
    <div class="topbar" v-show="!isShowComment">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)" >返回</a>
        <h1>{{homeworkInfo.studentName}}的作业</h1>
      </div>
      <div class="liner"></div>
    </div>
    <mt-loadmore :top-method="loadTop" v-show="!isShowComment" ref="loadmore">
    <div class="main-page" @click="isShowTop = false">
      <div class="dynamic homework-detail">
          <div>
            <div class="padding-15 clearfix bg-white">
              <div class="pull-left left-part"><div class="img-wrap small"><img :src="homeworkInfo.imageAddress ? baseAcessPath + homeworkInfo.imageAddress : img_default"  class="mid-align" /></div></div>
              <div class="right-part">
                <span class="font-16" style="color:#449;">{{homeworkInfo.userName}}</span>
                <p>{{homeworkInfo.content}}</p>
                <ul class="block clearfix imgs">
                  <li class="col-xs-4" v-for="(img, index) in homeworkInfo.imageList">
                    <div class="t-r-5">
                      <div class="out-wrap">
                        <span @click="showImgList(homeworkInfo.imageList, index)">
                          <!-- <img :data-original="img.baseAcessPath + img.thumbAddress" v-if="img.thumbAddress"/>
                          <img :src="img.baseAcessPath + img.thumbAddress" v-else/> -->
                          <img :src="img.baseAcessPath + img.thumbAddress" class="mid-align" />
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="clearfix">
                  <cite class="gray pull-left font-12">{{homeworkInfo.publishDate | dateDiff}}</cite>
                  <span class="pull-left margin-x-15 font-12" v-if="homeworkInfo.userId == teacherId && homeworkInfo.clientType == 'teacher'" @click="isHideDelhomework = false">删除</span>
                  <span class="pull-right icon-p-c" @click.stop="isShowTop = !isShowTop">更多</span>
                  <div class="tips-comwrap">
                    <div class="tip-comment" v-show="isShowTop">
                      <div class="col-xs-6" v-if="homeworkInfo.isDz"><span class="icon-praise" @click="cancelDz()">取消</span></div>
                      <div class="col-xs-6" v-else><span class="icon-praise" @click="dz()">点赞</span></div>
                      <div class="col-xs-6"><span class="icon-comment" @click="isShowComment = true">评论</span></div>
                    </div>
                  </div>
                </div>
                <div class="comment" v-if="(homeworkInfo.dzList && homeworkInfo.dzList.length > 0)|| (homeworkInfo.plList && homeworkInfo.plList.length > 0)">
                  <div class="icon-praise praiser" v-if="homeworkInfo.dzList && homeworkInfo.dzList.length > 0">
                  <span v-for="(dz, index) in homeworkInfo.dzList">
                    {{dz.commentUserName}} {{index == homeworkInfo.dzList.length - 1 ? '' : '、'}}
                  </span>
                  </div>
                  <div class="liner" v-show="(homeworkInfo.dzList && homeworkInfo.dzList.length > 0)|| (homeworkInfo.plList && homeworkInfo.plList.length > 0)"></div>
                  <ul class="con-comment" v-if="homeworkInfo.plList.length > 0">
                    <li class="clearfix" v-for="(pl, index) in homeworkInfo.plList" @click="showDelComment(pl, index)">
                      <span>{{pl.commentUserName}}:</span>
                      {{pl.content}}
                    </li>
                  </ul>
                </div>

              </div>
            </div>
            <div class="liner"></div>
            <div>
              <span class="block" style="margin:10px;">已阅：</span>
              <ul class="list-group-item">
                <li class="list-group">
                  <div class="liner"></div>
                  <div class="clearfix padding-15">
                    <div class="pull-left reader" v-for="item in homeworkInfo.readList">
                      <a class="block text-center" href="javascript:;">
                        <span class="img-wrap small block"><img :src="item.imageAddress ? baseAcessPath + item.imageAddress : img_default" width="100%" /></span>
                        <cite class="gray font-12">{{item.userName}}</cite>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      </div>
    </div>
    </mt-loadmore>

    <div class="main-page" v-show="isShowComment">
      <div class="topbar">
        <div class="clearfix main-wrap">
          <a class="pull-left img-back" @click.prevent="isShowComment = false">返回</a>
          <h1></h1>
          <span class="pull-right icon-right orange" @click="insertHomeWorkComment()">发送</span>
        </div>
        <div class="liner"></div>
      </div>

      <div class="padding-15 bg-white">
        <textarea class="font-14" width="100%" rows="5" placeholder="这一刻的想法..." v-model="content"></textarea>
      </div>
    </div>



    <!-- 删除动态 -->
    <div class="maskdiv" v-show="!isHideDelhomework" @click="isHideDelhomework = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p class="margin-15">确认要删除这条动态吗？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
              <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deleteHomeWork()">删除</a></div>
              <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideDelhomework = true">不删除</a></div>
            </div>
        </div>
      </div>
    </div>

    <!-- 删除评论 -->
    <div class="maskdiv" v-show="!isHideDelComment" @click="isHideDelComment = true">
      <div class="bottom-block text-center" style="background:none" @click.stop>
        <ul class="list-group-item  tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="deleteComment()"><span class="orange block font-16">删除</span></a>
          </li>
        </ul>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="isHideDelComment = true"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
    </div>

    <div class="maskdiv" @click="isShowImgs = false" v-if="isShowImgs" style="background:rgba(0,0,0,1)">
    <div class="imgs-box" >
      <div class="swiper-container" >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in imageList" style="height:100vh">
            <img :data-src="item.baseAcessPath + item.imageAddress" class="swiper-lazy bigger-pic hide" :thumbImg="item.baseAcessPath + item.thumbAddress">
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_homework_detail_para: service.setPara('getHomeWorkDetail'),
      delete_homework_para: service.setPara('deleteHomeWork'),
      insert_homework_comment_para: service.setPara('insertHomeWorkComment'),
      delete_homework_comment_para: service.setPara('deleteHomeWorkComment'),
      curcheId: 0,
      teacherId: 0,
      teacherName: '',
      homeWorkId: 0,
      isHideDelhomework: true,
      isHideDelComment: true,
      isShowImgs: false,
      isShowComment: false,
      homeworkInfo: {},
      baseAcessPath: '',
      isShowTop: false,
      delPl: {},
      content: ''
    }
  },
  mounted: function () {
    this.homeWorkId = this.$route.params.homeWorkId

    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId
    this.teacherName = this.login_data[this.cookie_login_data.index].teacherName
    this.baseAcessPath = this.cookie_login_data.baseAcessPath
    this.setPara()
    this.getHomeWorkDetail()
  },
  methods: {
    ...mapMutations([
      'updateHomeworkRed',
      'updateHomeworkState',
      'deleteHomework'
    ]),
    loadTop (id) {
      this.getHomeWorkDetail()
      this.$refs.loadmore.onTopLoaded(id)
    },
    setPara () {
      this.get_homework_detail_para.curcheId = this.curcheId
      this.get_homework_detail_para.homeWorkId = this.homeWorkId
      this.get_homework_detail_para.userId = this.teacherId
      this.get_homework_detail_para.userName = this.teacherName
      this.get_homework_detail_para.imageAddress = this.cookie_login_data.teacherIcon
    },
    getHomeWorkDetail () { // 获取动态列表
      let obj = {context: this, para: this.get_homework_detail_para, isIndicator: false, successFun: (response) => {
        let tempInfo = response.data
        tempInfo.isDz = false
        for (let j = 0; j < tempInfo.dzList.length; j++) {
          if (tempInfo.dzList[j].commentUserId == this.teacherId) {
            tempInfo.isDz = true
            break
          }
        }
        this.homeworkInfo = tempInfo
        // 更新红点状态
        let para = {homeworkId: this.homeworkInfo.homeWorkId, field1: 1}
        this.$store.dispatch('updateHomeworkRed', para)
        // 更新已读状态
        para = {homeworkId: this.homeworkInfo.homeWorkId, state: 1}
        this.$store.dispatch('updateHomeworkState', para)
      }}
      service.request(obj)
    },
    insertHomeWorkComment: function () { // 评论
      if ($.trim(this.content) == '') {
        Toast('评论不能为空')
        return
      }
      this.insert_homework_comment_para.userId = this.teacherId
      this.insert_homework_comment_para.userName = this.teacherName
      this.insert_homework_comment_para.homeWorkId = this.homeWorkId
      this.insert_homework_comment_para.content = $.trim(this.content)
      this.insert_homework_comment_para.type = 1

      let obj = {context: this, para: this.insert_homework_comment_para, successFun: (response) => {
        let plInfo = response.data
        this.homeworkInfo.plList.push(plInfo)
        this.content = ''
        this.isShowComment = false
      }}
      service.request(obj)
    },
    dz: function () { // 点赞
      this.insert_homework_comment_para.userId = this.teacherId
      this.insert_homework_comment_para.userName = this.teacherName
      this.insert_homework_comment_para.homeWorkId = this.homeWorkId
      this.insert_homework_comment_para.type = 0

      let obj = {context: this, para: this.insert_homework_comment_para, successFun: (response) => {
        this.homeworkInfo.isDz = true
        let dzInfo = response.data
        this.homeworkInfo.dzList.push(dzInfo)
      }}
      service.request(obj)
    },
    cancelDz: function () { // 取消点赞
      let item = {}
      let index = 0
      for (let i = 0; i < this.homeworkInfo.dzList.length; i++) {
        if (this.homeworkInfo.dzList[i].commentUserId == this.teacherId) {
          item = this.homeworkInfo.dzList[i]
          index = i
          break
        }
      }

      this.delete_homework_comment_para.commentId = item.commentId

      let obj = {context: this, para: this.delete_homework_comment_para, successFun: (response) => {
        Toast('取消成功')
        this.homeworkInfo.isDz = false
        this.homeworkInfo.dzList.splice(index, 1)
      }}
      service.request(obj)
    },
    deleteComment: function () { // 删除评论
      this.delete_homework_comment_para.commentId = this.delPl.commentId

      let obj = {context: this, para: this.delete_homework_comment_para, successFun: (response) => {
        Toast('删除成功')
        this.isHideDelComment = true
        this.homeworkInfo.plList.splice(this.delPl.index, 1)
      }}
      service.request(obj)
    },
    deleteHomeWork: function () { // 删除作业
      this.delete_homework_para.userId = this.teacherId
      this.delete_homework_para.homeWorkId = this.homeWorkId

      let obj = {context: this, para: this.delete_homework_para, successFun: (response) => {
        Toast('删除成功')
        this.$store.dispatch('deleteHomework')
        window.history.go(-1)
      }}
      service.request(obj)
    },
    showImgList: function (imgs, index) {
      var that = this
      this.isShowImgs = true
      this.imageList = imgs
      this.$nextTick(function () {
        that.mySwiper = new Swiper('.swiper-container', {
          // loop: true,
          // 如果需要分页器
          pagination: '.swiper-pagination',
          autoplayDisableOnInteraction: false,
          lazyLoading: true,
          autoHeight: true,
          initialSlide: index,
          onLazyImageLoad: function (swiper, slide, image) {
            $(image).before('<img class="swiper-lazy swiper-lazy-loaded " src="' + $(image).attr('thumbimg') + '">')
            $(image).before('<div class="swiper-lazy-preloader swiper-lazy-preloader-white" style="position:fixed"></div>')
            // console.log(image) // 哪个图片在加载
          },
          onLazyImageReady: function (swiper, slide, image) {
            $(image).prev('img').remove()
            $(image).removeClass('hide')
            $(image).addClass('thispic')
          },
          onSlideChangeEnd: function (swiper) {
            $('.swiper-slide').not('.swiper-slide-active').children('.bigger-pic').removeClass('thispic')
          }
        })
        $('.swiper-lazy-preloader-white').css('top', '50%')
      })
    },
    showDelComment: function (pl, index) { // 显示删除评论
      if (pl.commentUserId != this.teacherId) {
        return
      }
      this.isHideDelComment = false
      this.delPl = pl
      this.delPl.index = index
    }
  }
}
</script>
<style scoped>
  .main-page{padding-bottom:39px;}
</style>


// WEBPACK FOOTER //
// homeworkDetail.vue?473dc86f